import React from "react";
import { urlSafeBase64Decode } from "../../utils/base64";
import httpclient from "../../service/httpclient";
import {
  faCircleXmark,
  faCircleCheck,
} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./CheckoutPortal.scss";
import OrderService from "../../service/orderservice";
import { socket } from "../../App";
import PopModal from "../../components/modal/modal";

const WEIXIN_BRIDGE_TIMEOUT_MS = 10000;

function waitForWeixinJSBridge() {
  return new Promise((resolve, reject) => {
    if (window["WeixinJSBridge"]) {
      resolve(window["WeixinJSBridge"]);
      return;
    }

    let settled = false;
    const clearWait = () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
      document.removeEventListener("WeixinJSBridgeReady", onBridgeReady);
    };

    const onBridgeReady = () => {
      const bridge = window["WeixinJSBridge"];
      clearWait();
      settled = true;
      if (bridge) {
        resolve(bridge);
      } else {
        reject(new Error("微信支付环境未准备好，请刷新页面后重试"));
      }
    };

    const timeoutId = setTimeout(() => {
      clearWait();
      settled = true;
      reject(new Error("微信支付环境未准备好，请刷新页面后重试"));
    }, WEIXIN_BRIDGE_TIMEOUT_MS);

    const intervalId = setInterval(() => {
      if (settled || !window["WeixinJSBridge"]) {
        return;
      }
      clearWait();
      settled = true;
      resolve(window["WeixinJSBridge"]);
    }, 100);

    document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
  });
}

function invokeWeixinPay(params) {
  return waitForWeixinJSBridge().then(
    (bridge) =>
      new Promise((resolve) => {
        bridge.invoke("getBrandWCPayRequest", params, (res) => {
          resolve(res);
        });
      })
  );
}

// 只有微信浏览器才会进入本页面。本页面网址必须是 https://icdesign.com/checkout
export default class CheckoutPortal extends React.Component {
  orderService = new OrderService();

  state = {
    phase: "init",
    message: "",
  };

  params = JSON.parse(
    urlSafeBase64Decode(window.location.hash.replace(/^#/, ""))
  );

  async componentDidMount() {
    let timer = setInterval(() => {
      socket.emit("heartBeat", this.params.orderId);
    }, 1000);
    const clearHeartbeat = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    try {
      const response = await fetch(
        httpclient.server_url + "/order/getWechatPayParams",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${this.params.token}`,
          },
          body: JSON.stringify({ order_id: this.params.orderId }),
        }
      );
      const wechatPayParams = await response.json();

      if (wechatPayParams.ErrorNoOpenId) {
        clearHeartbeat();
        window.location.href = `${httpclient.server_url}/wxauth/bind?token=${
          this.params.token
        }&jumpBackUrl=${encodeURIComponent(window.location.href)}`;
        return;
      }
      const jumpBack = () => {
        const jumpBackUrl = this.orderService.getOrderJumpBackUrl(
          this.params.orderId
        );
        if (jumpBackUrl) {
          window.location.href = jumpBackUrl;
        }
      };
      const weixinPayResult = await invokeWeixinPay(wechatPayParams);
      clearHeartbeat();
      const errMsg = weixinPayResult?.err_msg || "微信支付未返回结果";
      if (errMsg !== "get_brand_wcpay_request:ok") {
        this.setState({ phase: "error", message: errMsg });
        return;
      }
      this.setState({ phase: "successful", message: "您已成功支付" });
      PopModal({
        title: (
          <div>
            <div style={{ textAlign: "center", padding: "10px" }}>支付成功</div>
            <div
              style={{ textAlign: "center", color: "gray", fontSize: "14px" }}
            >
              请使用微信扫码入群，加入学习讨论
            </div>
          </div>
        ),
        body: (
          <div>
            <img
              alt="微信群二维码"
              style={{ width: "100%", padding: "0 10px 10px 10px" }}
              src="https://kanjia.tuozhanpian.com:8282/qrcodes/icdesign"
            />
          </div>
        ),
        borderRadius: 20,
        width: 300,
        closeButtonPosition: "bottom",
        onClose: jumpBack,
      });
    } catch (error) {
      clearHeartbeat();
      this.setState({
        phase: "error",
        message: error?.message || "微信支付拉起失败，请刷新页面后重试",
      });
    }
  }

  render() {
    return (
      <div
        style={{ paddingTop: 100, textAlign: "center" }}
        className={"checkout-portal"}
      >
        {this.state.phase === "init" && <div>请完成支付</div>}
        {this.state.phase === "error" && (
          <div className="payment-error">
            <FontAwesomeIcon icon={faCircleXmark} />
            <div>{this.state.message}</div>
          </div>
        )}
        {this.state.phase === "successful" && (
          <div className="payment-successful">
            <FontAwesomeIcon icon={faCircleCheck} />
            <div>{this.state.message}</div>
          </div>
        )}
      </div>
    );
  }
}
